import { useCallback } from "react";

import { styled } from "@linaria/react";
import { useNavigate } from "@tanstack/react-router";

import { SourceResource } from "@gx/ts-contracts/services/source/resources/source_pb";

import SourcesTable from "@/pages/sources/views/table/SourcesPageBodyTable";

const SourcesPageBodySourcesListWrapper = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

interface SourcesPageBodyTableViewProps {
  sources?: SourceResource[];
  isLoading: boolean;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  fetchNextPage?: () => void;
}

const SourcesPageBodyTableView = ({
  isLoading,
  sources,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
}: SourcesPageBodyTableViewProps) => {
  const navigate = useNavigate();

  const handleRowClick = useCallback(
    (row: { original: SourceResource }) => {
      void navigate({
        to: ".",
        search: (prev) => ({ ...prev, sourceId: row.original.id }),
      });
    },
    [navigate],
  );

  return (
    <SourcesPageBodySourcesListWrapper>
      <SourcesTable
        data={sources ?? []}
        isLoading={isLoading}
        onRowClick={handleRowClick}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        fetchNextPage={fetchNextPage}
      />
    </SourcesPageBodySourcesListWrapper>
  );
};

export default SourcesPageBodyTableView;
